<main fxLayout="column" fxLayoutAlign="center center">
  <h1>{{'textDeviceSelection' | translation}}</h1>
</main>
